// Root Reducer

import { combineReducers } from "redux";
import authUserReducer from "./authUser";
import MomentosReducers from "./MomentosReducer";
import fanMomentoReducer from "./FanReducers";
import draftDataReducer from "./draftDataReducer";
import QRReducers from "./qrCodeReducer";

export let rootReducer = combineReducers({
    authUser: authUserReducer,
    momentos: MomentosReducers,
    fanReducer: fanMomentoReducer,
    draftReducer: draftDataReducer,
    qrReducer: QRReducers,
});

export default rootReducer;
